import styled from "@emotion/styled";
import { Chip } from "@avenue-8/sidekick-ui";

export const ChipStripMask = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  display: flex;
  mask-image: linear-gradient(
    to right,
    ${(p) => p.theme.text.colors.primary} calc(100% - 2rem),
    transparent 100%
  );
  -webkit-mask-image: linear-gradient(
    to right,
    ${(p) => p.theme.text.colors.primary} calc(100% - 2rem),
    transparent 100%
  );
`;

export const ChipStrip = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  align-items: center;
`;

export const ChipLink = styled.a`
  display: inline-flex;
  color: inherit;
  text-decoration: none;
`;

export const SummaryChip = styled(Chip)`
  flex: 0 0 auto;
  max-width: 12rem;
  background-color: ${(p) => p.theme.colors.background5};

  .MuiChip-icon {
    font-size: 1rem;
    color: ${(p) => p.theme.text.colors.brand};
  }

  .MuiChip-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: ${(p) => p.theme.text.fontSizes.s};
    color: ${(p) => p.theme.text.colors.brand};
  }
`;
